import { render, staticRenderFns } from "./PauseSelectedCard.vue?vue&type=template&id=68e084da"
import script from "./PauseSelectedCard.vue?vue&type=script&lang=js"
export * from "./PauseSelectedCard.vue?vue&type=script&lang=js"
import style0 from "./PauseSelectedCard.vue?vue&type=style&index=0&id=68e084da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports